import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import type { SharedState } from '@avalara/types/index';
import type { IStepper } from '@avalara/types/progress-bar';
import { initializeProgressBar } from '../actions/progress-bar';

const ProgressBar = () => {
  const {
    progressBar: { currentStep, steps },
  } = useSelector<SharedState, SharedState>((s) => s);
  const stepper = useRef<IStepper | null>(null);

  useEffect(() => {
    if (stepper.current != null) {
      stepper.current.stepItems = steps;
    }
  }, [steps]);

  useEffect(() => {
    if (stepper.current != null && currentStep < steps.length) {
      stepper.current.stepItems = steps;
      initializeProgressBar(steps);
    }
  }, [currentStep, steps]);

  // No point in rendering a stepper with only 1 step:
  if (steps.length < 2) return null;

  return <s-stepper ref={stepper} />;
};

export default ProgressBar;
